import BaseModel from '@/data/models/base/base-model';
import TypeUtils from '@/helpers/type-utils';

export default class MeterReadingCsvMapping extends BaseModel {

  meterId: string;
  filename: string;
  headerLinesCount: number;
  dateColumn: number;
  valueColumn: number;
  dateFormat: string;
  isIndex: boolean;

  static map(data: Partial<MeterReadingCsvMapping>): MeterReadingCsvMapping | null {
    if (!data) {
      return null;
    }

    const meterReadingCSVMapping = new MeterReadingCsvMapping();

    meterReadingCSVMapping.id = TypeUtils.hasStringOrDefault(data.id);
    meterReadingCSVMapping.meterId = TypeUtils.hasStringOrDefault(data.meterId);
    meterReadingCSVMapping.filename = TypeUtils.hasStringOrDefault(data.filename, data.meterId);
    meterReadingCSVMapping.headerLinesCount = TypeUtils.hasNumberOrDefault(data.headerLinesCount, 0);
    meterReadingCSVMapping.dateColumn = TypeUtils.hasNumberOrDefault(data.dateColumn, 0);
    meterReadingCSVMapping.valueColumn = TypeUtils.hasNumberOrDefault(data.valueColumn, 1);
    meterReadingCSVMapping.dateFormat = TypeUtils.hasStringOrDefault(data.dateFormat, 'DD.MM.YYYY HH:mm');
    meterReadingCSVMapping.isIndex = TypeUtils.hasBooleanOrDefault(data.isIndex, false);

    return meterReadingCSVMapping;
  }

  toJSON(): Partial<MeterReadingCsvMapping> {
    return {
      'meterId': this.meterId,
      'filename': this.filename,
      'headerLinesCount': this.headerLinesCount,
      'dateColumn': this.dateColumn,
      'valueColumn': this.valueColumn,
      'dateFormat': this.dateFormat,
      'isIndex': this.isIndex
    };
  }

}
